function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon';
require("./Button.css");
var styles = {
  "Root": "Button-module-Root_wsW",
  "Text": "Button-module-Text_1-J",
  "hasOneIcon": "Button-module-hasOneIcon_3oC",
  "sSize": "Button-module-sSize_24u",
  "mSize": "Button-module-mSize_uvb",
  "lSize": "Button-module-lSize_2C6",
  "hasOnlyText": "Button-module-hasOnlyText_1Mm",
  "hasIconAndText": "Button-module-hasIconAndText_225",
  "fullWidth": "Button-module-fullWidth_dw-",
  "primaryTheme": "Button-module-primaryTheme_2Rz",
  "lightTheme": "Button-module-lightTheme_7ED",
  "neutralTheme": "Button-module-neutralTheme_2sv",
  "outlinedSolidVariant": "Button-module-outlinedSolidVariant_17K",
  "outlinedDashedVariant": "Button-module-outlinedDashedVariant_3op",
  "transparentTheme": "Button-module-transparentTheme_3Pr"
};
export const ButtonThemes = {
  primary: 'primary',
  light: 'light',
  neutral: 'neutral',
  transparent: 'transparent'
};
export const ButtonVariants = {
  filled: 'filled',
  outlinedSolid: 'outlinedSolid',
  outlinedDashed: 'outlinedDashed'
};
export const ButtonSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const ButtonTags = {
  a: 'a',
  button: 'button'
};
export const Button = ({
  checked,
  children,
  className,
  controlRef,
  disabled,
  fullWidth,
  innerRef,
  size = ButtonSizes.m,
  style = {},
  tag = ButtonTags.button,
  theme = ButtonThemes.primary,
  variant = ButtonVariants.filled,
  ...props
}) => {
  const Component = tag;
  const rootProps = {
    ...props
  };
  if (tag === ButtonTags.button) {
    const {
      name
    } = props;
    rootProps.disabled = Boolean(disabled);
    rootProps.type = props.type || 'button';
    Boolean(name) && (rootProps.name = name);
  }
  if (tag === ButtonTags.a) {
    /** @see {@link https://www.scottohara.me/blog/2021/05/28/disabled-links.html} */
    if (disabled) {
      rootProps.href = undefined;
      rootProps.role = 'link';
    }
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: innerRef || controlRef,
    className: cn(styles.Root, {
      [styles.fullWidth]: fullWidth,
      [styles.hasOneIcon]: !Array.isArray(children) && children?.type === Icon,
      [styles.hasOnlyText]: !Array.isArray(children) && typeof children === 'string',
      [styles.hasIconAndText]: Array.isArray(children) && children.length === 2 && (children[1]?.type === Icon || typeof children[1] === 'string')
    }, styles[`${theme}Theme`], styles[`${variant}Variant`], styles[`${size}Size`], className),
    style: style
  }, disabled && {
    [tag === ButtonTags.button ? 'disabled' : 'aria-disabled']: disabled
  }, checked && {
    'aria-pressed': checked
  }, rootProps), Children.map(children, child => {
    return typeof child === 'string' ? /*#__PURE__*/React.createElement("div", {
      className: styles.Text
    }, child) : child;
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Button.displayName = 'Button';
}